export default "__VITE_ASSET__B96_0Q8O__"